module.exports = __webpack_public_path__ + "img/Card Pack.38e77f9a.png";